import clsx from 'clsx';
import React from 'react';

export const Divider = ({ className }: { className?: string }) => (
  <div className={clsx('w-full h-[1px] bg-[#B4B4B4]', className)} />
);
